import React from 'react';
import type { ReactionType } from '../../types';

const FISH = {
  'flame-angelfish': { name: 'Flame Angelfish', duration: 17 },
  'royal-gramma': { name: 'Royal Gramma', duration: 20 },
  'clown-triggerfish': { name: 'Clown Triggerfish', duration: 23 },
} as const;
export type ReefFishId = keyof typeof FISH;

const CSS = `
@keyframes reef-drift { 0%,100%{transform:translateX(7%)} 50%{transform:translateX(72%)} }
@keyframes reef-face { 0%,49.99%{transform:scaleX(-1)} 50%,100%{transform:scaleX(1)} }
@keyframes reef-hover { 0%,100%{transform:translateY(0) rotate(-1deg)} 50%{transform:translateY(-7px) rotate(1deg)} }
@keyframes reef-react { 0%,100%{filter:brightness(1)} 50%{filter:brightness(1.14)} }
.reef-fish-swim{position:absolute;inset:0;animation:reef-drift var(--reef-duration) ease-in-out infinite}
.reef-fish-face{width:100%;height:100%;animation:reef-face var(--reef-duration) step-end infinite}
.reef-fish-bob{width:100%;height:100%;animation:reef-hover 4.6s ease-in-out infinite}
.reef-fish-reacting .reef-fish-bob{animation:reef-react 1.1s ease-in-out infinite}
.reef-fish-static .reef-fish-swim,.reef-fish-static .reef-fish-face,.reef-fish-static .reef-fish-bob{animation:none!important}
.reef-fish-static .reef-fish-swim{transform:translateX(22%)}
.reef-fish-static .reef-fish-face{transform:scaleX(-1)}
@media(prefers-reduced-motion:reduce){.reef-fish-swim,.reef-fish-face,.reef-fish-bob{animation:none!important}}
`;

export function ReefFish({ id, reaction, reducedMotion, speed=1, active=false, dimmed=false }: {
 id: ReefFishId; reaction: ReactionType|null; reducedMotion:boolean;speed?:number;active?:boolean;dimmed?:boolean;
}) {
 const fish=FISH[id];
 const duration=`${(fish.duration/Math.max(.1,speed)).toFixed(2)}s`;
 return <div className={`reef-fish ${reducedMotion?'reef-fish-static':''} ${reaction && !reducedMotion?'reef-fish-reacting':''}`}
   role="img" aria-label={fish.name} style={{position:'absolute',inset:0,opacity:dimmed?.33:1,filter:active?'drop-shadow(0 0 15px #7dece9)':undefined,pointerEvents:'none'}}>
   <style>{CSS}</style>
   <div className="reef-fish-swim" style={{'--reef-duration':duration} as React.CSSProperties}>
    <div style={{position:'absolute',top:'50%',left:0,width:'21%',aspectRatio:'1.3 / 1',transform:'translateY(-50%)'}}>
     <div className="reef-fish-face" style={{'--reef-duration':duration} as React.CSSProperties}>
      <div className="reef-fish-bob">
       <img draggable={false} alt="" src={`/art/fish/reef-approved-v1/${id}/approved-master.png`} style={{width:'100%',height:'100%',objectFit:'contain'}} />
      </div>
     </div>
    </div>
   </div>
 </div>;
}
